<template>
  <div class="is-flex is-justify-content-center af-footer">
    <a :href="$t('af:footer.link.privacy_policy')" target="_blank">{{
      $t("af:footer.title.privacy_policy")
    }}</a>
    <a :href="$t('af:footer.link.user_agreement')" target="_blank">{{
      $t("af:footer.title.user_agreement")
    }}</a>
    <a :href="$t('af:footer.link.instacash')" target="_blank"
      >{{ $t("af:footer.title.instacash") }}{{ year }}</a
    >
  </div>
</template>

<script>
export default {
  name: "TheFooter",
  computed: {
    year() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style scoped>
.af-footer {
  padding: 20px;
}

a {
  color: #adb7c4;
  font-size: 12px;
  margin: 0 8px;
}
</style>
